import { Provider } from "@redotech/redo-model/order";
import { ConditionTypeDetailsProps } from "@redotech/redo-return-ui/flows/return-flow/condition";
import {
  PlatformState,
  platformMap,
} from "@redotech/redo-return-ui/flows/return-flow/condition-types/platform";
import { RedoListItem } from "@redotech/redo-web/arbiter-components/list/redo-list";
import { RedoSingleSelectDropdownInput } from "@redotech/redo-web/arbiter-components/select-dropdown/redo-single-select-dropdown-input";
import { memo, useMemo } from "react";

const platformToProvider: Record<string, Provider> = {
  Shopify: Provider.SHOPIFY,
  "Comment Sold": Provider.COMMENTSOLD,
  "Commerce Cloud": Provider.COMMERCE_CLOUD,
};

export const PlatformDetails = memo(function PlatformDetails({
  state,
  setState,
  disabled,
}: ConditionTypeDetailsProps<PlatformState>) {
  const platformOptions: RedoListItem<string>[] = useMemo(
    () =>
      [...platformMap.values()].map((platform) => ({
        id: platform,
        value: platform,
        type: "text" as const,
        text: platform,
      })),
    [],
  );

  const selectedPlatform = state
    ? platformOptions.find((option) => option.value === platformMap.get(state))
    : undefined;

  return (
    <RedoSingleSelectDropdownInput
      disabled={disabled}
      flexGrow
      label="Platform"
      options={platformOptions}
      optionSelected={({ item }) => {
        const provider = platformToProvider[item.value];
        setState(provider ?? null);
      }}
      placeholder="Select platform..."
      selectedItem={selectedPlatform}
      size="xs"
    />
  );
});
